<template>
  <Dropdown
    ref="sortingDropdown"
    class="charter-search-sorting flex flex-row items-center"
    full-width
    close-on-click
  >
    <template #trigger="{ toggle, isOpen }">
      <div class="flex size-full">
        <button
          class="btn grow flex flex-row items-center justify-between relative"
          type="button"
          @click="toggle"
        >
          <span class="mx-1">
            {{ $t(selectedName) }}
          </span>
          <div class="icon-dropdown">
            <fa :icon="isOpen ? 'chevron-up' : 'chevron-down'" />
          </div>
        </button>
      </div>
    </template>
    <template #content>
      <div class="w-full bg-white py-2">
        <button
          v-for="{ id, translationKey } in sortOptions"
          :key="id"
          class="dropdown-item"
          type="button"
          @click="update(id)"
        >
          <span>
            {{ $t(translationKey) }}
          </span>
        </button>
      </div>
    </template>
  </Dropdown>
</template>

<script>
import { mapActions, mapState } from 'pinia'

export default defineNuxtComponent({
  emits: ['update'],

  computed: {
    ...mapState(useCharterPackagesStore, {
      sortBy: 'sortBy',
      sortOptions: 'getSortingOptions',
    }),

    selectedName () {
      const found = this.sortOptions.find(({ id }) => id === this.sortBy)

      return found ? found?.translationKey : this.sortOptions[0].translationKey
    },
  },

  methods: {
    ...mapActions(useCharterPackagesStore, {
      setSortBy: 'SET_SORT_BY',
    }),

    update (id) {
      this.setSortBy(id)
      this.$emit('update', id)

      // Manually hide here because iOS
      this.$refs.sortingDropdown.hide()
    },
  },
})
</script>

<style lang="scss">
.charter-search-sorting {
  border: 1px solid theme('colors.gray.DEFAULT');

  .dropdown__toggle {
    overflow: hidden;

    button {
      font-size: inherit;
      padding: 0 0 0 0.75em;
    }
  }
  &, .icon-dropdown {
    height: 2.5rem;
  }
  .icon-dropdown {
    color: theme('colors.white');
    width: 2.5rem;
    right: -1px;
    top: -1px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .fa {
      color: theme('colors.white');
      svg {
        fill: theme('colors.white');
      }
    }
    .identity--rolfs & {
      background: theme('colors.blue.DEFAULT');
    }
    .identity--solresor & {
      background: theme('colors.orange.DEFAULT');
    }
  }
  span {
    text-transform: none;
    font-weight: normal;
  }

  &__popper {
    .v-popper__inner {
      border-radius: 0;
    }
  }
}
</style>
